module.exports = __webpack_public_path__ + "img/kid13.68034f2c.png";